import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { Typography, Box } from "@mui/material";
import Disconnect from '../../assets/img/disconnect.png';


function PopupFGTracking(props) {

    return (
        <div>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // โปร่งใส
                    zIndex: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img src={Disconnect} height="100px" />
                <Typography sx={{ color: "#EF193B", fontWeight: "bold", fontSize: 36 }}>
                    Disconnect
                </Typography>
                <Typography sx={{ color: "#EF193B", fontWeight: "bold", fontSize: 36 }}>
                    {props.line}
                </Typography>
            </Box>
        </div>
    );
}

PopupFGTracking.propTypes = {}

export default PopupFGTracking